export var sdkInfo = {
  host: 'npmjs.com',
  version: '13.0.0',
  name: '@kontent-ai/delivery-sdk'
};